<rid-mechanic-background />
@let current = phase() === 'TEXT' ? contents().at(index()) : undefined;
@let isSettingLength = current && current.klankvoet === '>' && !current.isLengthConfirmed;
@let reachedMaxChars =
  !isSettingLength && current && current.klankvoet === '>' && current.length === current.content.length && current.length > 0;

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Algoritme" [steps]="0" [progress]="0" />

  <rid-mechanic-content>
    <div class="grid justify-items-center gap-16">
      <div class="flex gap-3">
        <div class="relative min-w-md">
          <!-- background -->
          @if (phase() == 'KLANKVOET') {
            <rid-text-input
              class="absolute inset-0 size-full"
              appearance="DEFAULT"
              animate.enter="wait-750 anim-pop-in"
              animate.leave="anim-fade-out"
              ridSfx="BUBBLE_POP"
            />
          }

          <!-- content -->
          <div class="relative mx-4 flex h-full items-center place-self-center" [class.gap-4]="!compressed()">
            @for (k of contents(); track $index) {
              @if (k.klankvoet === '>') {
                <rid-algorithm-normale-voet
                  #voet
                  [mode]="phase() === 'TEXT' && $index <= index() ? 'AS_INPUT' : 'ICON'"
                  [voet]="k"
                  [compressed]="compressed()"
                />
              } @else {
                <rid-algorithm-stomme-voet
                  #voet
                  [mode]="phase() === 'TEXT' && $index <= index() ? 'AS_INPUT' : 'ICON'"
                  [voet]="k"
                  [isCurrent]="$index === index()"
                  [compressed]="compressed()"
                />
              }
            }
          </div>
        </div>

        <!-- controls -->
        <div class="flex flex-col gap-4" animate.enter="wait-750 anim-pop-in" ridSfx="BUBBLE_POP">
          <rid-button appearance="DANGER" [disabled]="!canBackspace()" (click)="pop()">
            <i-backspace class="size-[1lh]" />
          </rid-button>
          <rid-button [disabled]="!canOkay()" (click)="okay()">
            <i-enter class="size-[1lh]" />
          </rid-button>
        </div>
      </div>

      <!-- length configuration -->
      @if (isSettingLength) {
        <div class="flex gap-2">
          <rid-button [disabled]="current.length === 0" (click)="setLength(current.length - 1)">-</rid-button>
          <rid-button (click)="setLength(current.length + 1)">+</rid-button>
        </div>
      }

      <rid-syllabic-keyboard
        [class.hidden]="isSettingLength"
        [layout]="layout()"
        mode="KLANK"
        [mask]="mask() ?? (reachedMaxChars ? [] : baseMask())"
        [highlightMask]="highlightMask()"
        [disabled]="false"
        (typed)="onTyped($event)"
      />
    </div>
  </rid-mechanic-content>
</rid-mechanic-wrapper>
